const STORAGE_KEYS = {
	PLATFORM_OS: 'platform_os',
	LAST_CHAT_AI: 'last-chat-ai',
	ESCALATION_FORM: 'escalation-form',
	IS_SIDEBAR_EXPANDED: 'is-sidebar-expanded',
	NOTIFICATIONS_VIEWED: 'notifications-viewed',
	LAST_REFRESH_ORDER: 'last-refresh-order',
	LINKING_FLOW_CONFIG: 'linking-flow-config',
	LINKING_FAILED_INFO: 'linking-failed-info',
	LINKING_FAILED_ATTEMPTS: 'linking-failed-attempts',
	LINKING_RESCUE_DISMISSED: 'linking-rescue-dismissed',
	LINKING_LAST_RFC: 'linking-last-rfc',
	LINKING_SUCCESS_INFO: 'linking-success-info',
	LINKING_WAITING_EXPERIENCE: 'linking-waiting-experience',
	CHECKOUT_ORDER_PAYLOAD: 'checkout-order-payload',
	NATIVE_REVIEW_REQUESTED_AT: 'native-review-requested-at',
	APP_BANNER_DISMISSED_AT: 'app-banner-dismissed-at',
	/** Prefix; the full key adds platform and threshold (`features/app-update`). */
	APP_UPDATE_DISMISSED: 'app-update-dismissed',
	ONBOARDING_TARGET: 'onboarding_target',
	/** Entry intent of the `?intent=` link, kept apart from the ally target;
	 * see features/onboarding/lib/onboardingTargets.ts. */
	ENTRY_INTENT: 'entry_intent',
	/** Intent del deep-link de campaña a Certificados (t-152); ver
	 * shared/deeplinks/certificatesDeeplink.ts. */
	CERTIFICATES_DEEPLINK: 'certificates_deeplink',
	/** Prefijo del estado de los tours guiados; la llave completa la arma
	 * `tourStorageKey` en shared/tour/tourStorage.ts. */
	GUIDED_TOUR: 'guided-tour',
	/** Estado por usuario de las novedades del sidebar; ver `shell/nav/noveltyStore.ts`. */
	SIDEBAR_NOVELTY: 'sidebar-novelty',
};

export default STORAGE_KEYS;
